export default __webpack_public_path__ + "static/media/011-k.d38d5049.svg";